import React from 'react';
import Button from 'shared/components/andtComponents/Button';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useCostCenters } from 'users/new-user-management/hooks/reactQuery/useCostCenters';
import { UnassignedAccountProps } from './Interfaces.ts';
import CostCentersSelector from '../../components/CostCentersSelector';
import { UseMutationResult } from '@tanstack/react-query';

interface UpdateCostCenterPayload {
  costCenterId: string;
  costCenterAccountsData: {
    accountsPayloadToAdd: {
      payerWithLinkedAccounts: {
        payerAccountId: string;
        linkedAccountIds: string[];
      }[];
    };
  };
}
const AssignTo = ({ selectedAccounts }: { selectedAccounts: UnassignedAccountProps[] }) => {
  const result = useCostCenters();
  const updateDataAccessCostCenter = result.updateDataAccessCostCenter as unknown as UseMutationResult<
    unknown,
    unknown,
    UpdateCostCenterPayload
  >;

  const assignAccountsToCostCenter = async (costCenterId: string) => {
    if (!selectedAccounts?.length) {
      return;
    }

    const accountsGroupedByPayer: { [key: string]: string[] } = selectedAccounts.reduce((acc, account) => {
      const payerAccountId = account.payerAccountId;
      if (!acc[payerAccountId]) {
        acc[payerAccountId] = [];
      }
      if (!acc[payerAccountId].includes(account.linkedAccountId)) {
        acc[payerAccountId].push(account.linkedAccountId);
      }
      return acc;
    }, {});

    await updateDataAccessCostCenter.mutateAsync({
      costCenterId: costCenterId,
      costCenterAccountsData: {
        accountsPayloadToAdd: {
          payerWithLinkedAccounts: Object.entries(accountsGroupedByPayer).map(([payerAccountId, linkedAccountIds]) => ({
            payerAccountId: payerAccountId,
            linkedAccountIds: linkedAccountIds,
          })),
        },
      },
    });
  };

  return (
    <CostCentersSelector onCostCenterSelected={assignAccountsToCostCenter}>
      <Button
        isTextButton
        icon={() => <GenerateIcon iconName={ICONS.caretDown.name} />}
        iconPlacement="right"
        onClick={() => {}}
        text="Assign to"
      />
    </CostCentersSelector>
  );
};

export default AssignTo;
